import React,{useState,useEffect,useRef} from "react";
import {Link,useNavigate} from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../../../router/all_routes";
/* -- biz9 import start -- */
import {DateTime,Str} from "biz9-utility";
import {Portal_Table,Order_Logic} from "biz9-store";
import {Message,Type,Url,Field,Title} from "../../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Template,Storage,System} from "../../../../../project";
import {Data_Logic} from "biz9-data-app";
/* -- biz9 import end -- */
const Order_Status_Edit_Modal = (props) => {
    const [order,setOrder] = useState(props.order);
    const [val_sub_page_title,setValSubPageTitle] = useState("Edit Status");
    const [order_status_types,setOrderStatuses] = useState(Order_Logic.get_status_types());
    const [sel_order_status_type,setSelOrderStatusType] = useState(null);
    useEffect(() => {
        setSelOrderStatusType(Order_Logic.get_status_types().find(option => option.value === props.order.status_type));
        setOrder(props.order);
            },[props]);
    const updateOrderStatusType = (selectedOption) => {
        setSelOrderStatusType(selectedOption);
    };
    async function btn_post(){
        /*
        if(!Str.check_is_null(sel_order_status_type)){
            let post_data = Data_Logic.get(Portal_Table.ORDER,order.id,{data:{status_type:sel_order_status_type.value}});
	        const [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),Portal_Table.ORDER,post_data);
            props.onUpdate(data);
        }else{
			window.alert("Select A Status");
        }
        */
    };
    return (
        <>
        <div className="modal new-modal fade" id="order_status_edit_modal" data-keyboard="false" data-backdrop="static">
        <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
        <div className="modal-header">
        <h5 className="modal-title">{val_sub_page_title}</h5>
        <button type="button" className="close-btn" data-bs-dismiss="modal">
        <span>×</span>
        </button>
        </div>
        <div className="modal-body">
        <div className="row">
        <div className="col-md-12">
        <div className="amt-wrap">
<div className="form-wrap">
<label className="form-label mb-1 fw-medium text-dark">
Status
</label>
<Select classNamePrefix="react-select" className="select" styles={Style.customStyles} value={sel_order_status_type} onChange={updateOrderStatusType} placeholder="Choose A Status" options={order_status_types} />
</div>
</div>
</div>
<div className="col-md-12">
<Link onClick={btn_post} to="#" data-bs-dismiss="modal" className="btn btn-primary w-100">
Save
</Link>
</div>
</div>
</div>
</div>
</div>
</div>
</>
);
};
export default Order_Status_Edit_Modal;
